import { Link, useLocation} from "react-router-dom";
import logoDark from '@images/common/text-logo.svg'
import { Nav } from "./index.styled";
import { RouteNames } from "@router/config";
import OutlineButton from "../OutlineButton";
import { useTheme } from "styled-components";
import { useDispatch } from "react-redux";
import { setModalOpen } from "@features/appActionSlice";
import { AppDispatch } from "@redux/store";

const Navbar = () => {
  const theme = useTheme()
  const location = useLocation()
  const breakpoint1 = theme.breakpoints.breakpoint1
  const dispatch : AppDispatch = useDispatch()

  // We want to render navbar on home screen only in mobile view
  const renderingCondition = location.pathname !== RouteNames.HOME ? true : window.innerWidth < +breakpoint1.substring(0,breakpoint1.length-2)
  return (
    renderingCondition
      ? <Nav className="navbar">
        <Link to="/">
          <div className="img-container">
            <img
              src={logoDark}
              loading="lazy"
              alt="loophealth logo"
              width={150}
            />
          </div>
        </Link>
        <div className="button-container">
          <OutlineButton
            text="Talk to us"
            handleClick={() => dispatch(setModalOpen(true))}  
            textColor={theme.colors.grass10}
            backgroundColor={theme.colors.emerald30}
          />
        </div>
      </Nav>
      : <div></div> 
  );
};

export default Navbar;